import { t } from '../../i18n/t';
import { localizedPath } from '../../i18n/path';

/*
// Previous logo — drove the wordmark from the configured brand name.
import { useShared } from './Layout';
import { splitBrandWordmark } from '../../utils/brand';

export function Logo({ tone = 'light' }: { tone?: 'light' | 'dark' }) {
  const { brand } = useShared();
  const { brandName, tld } = splitBrandWordmark(brand.name);
  const nameColor = tone === 'dark' ? 'text-white' : 'text-primary-500';
  const tldColor = tone === 'dark' ? 'text-accent-300' : 'text-accent-500';
  const subtitleColor =
    tone === 'dark' ? 'text-white/70 hover:text-white' : 'text-neutral-500 hover:text-primary-500';

  return (
    <div className="inline-flex flex-col">
      <a
        href={localizedPath('/')}
        className="group no-underline transition-opacity duration-200 hover:opacity-85"
        aria-label={t('ui.logo.home', { brand: brand.name })}
      >
        <span className="font-display whitespace-nowrap text-[1.375rem] font-bold leading-none sm:text-[1.625rem]">
          <span className={nameColor}>{brandName}</span>
          {tld && <span className={tldColor}>{tld}</span>}
        </span>
      </a>
      <span className={`mt-0.5 whitespace-nowrap text-[0.6875rem] font-medium uppercase tracking-wide sm:text-xs ${subtitleColor}`}>
        {brand.brokerLabel}
      </span>
    </div>
  );
}
*/

const WORDMARK_NAME = 'kreditiem';
const WORDMARK_TLD = '.lv';

export function Logo({ tone = 'light' }: { tone?: 'light' | 'dark' }) {
  const nameColor = tone === 'dark' ? 'text-white' : 'text-primary-500';
  const tldColor = tone === 'dark' ? 'text-accent-300' : 'text-accent-500';
  const descriptorColor =
    tone === 'dark' ? 'text-white/70 hover:text-white' : 'text-neutral-500 hover:text-primary-500';

  return (
    <div className="inline-flex flex-col">
      <a
        href={localizedPath('/')}
        className="group no-underline transition-opacity duration-200 hover:opacity-85"
        aria-label={t('ui.logo.home', { brand: `${WORDMARK_NAME}${WORDMARK_TLD}` })}
      >
        <span className="font-display whitespace-nowrap text-[1.375rem] font-bold leading-none sm:text-[1.625rem]">
          <span className={nameColor}>{WORDMARK_NAME}</span>
          <span className={tldColor}>{WORDMARK_TLD}</span>
        </span>
      </a>
      <span
        className={`mt-0.5 whitespace-nowrap text-[0.6875rem] font-medium uppercase tracking-wide sm:text-xs ${descriptorColor}`}
      >
        {t('ui.logo.descriptor')}
      </span>
    </div>
  );
}
